type fileBlob = { blob: Blob; fileName: string };

const WINDOWS_RESERVED_NAMES = /^(con|prn|aux|nul|com\d|lpt\d)$/i;

export function filenamify(
    input: string,
    { replacement = '' } = {},
): string {
    if (typeof input !== 'string') throw new TypeError('Expected a string');

    let name = input
        .replace(/[<>:"/\\|?*\u0000-\u001F]/g, replacement) // eslint-disable-line no-control-regex
        .replace(/[\u0000-\u001F\u0080-\u009F]/g, replacement) // eslint-disable-line no-control-regex
        .trim();

    name = name.replace(/[. ]+$/, '');

    if (WINDOWS_RESERVED_NAMES.test(name)) {
        name = `${name}${replacement}`;
    }

    return name || replacement;
}

export const DEFAULT_DOWNLOAD_FILENAME = 'Answer';

export const LIVEBOARD_STYLING_ENABLED_PARAM = 'isLiveboardStylingEnabled';
export const KPI_CHART_ENHANCEMENTS_PARAM = 'enableKPIChartEnhancements';

export const downloadFileUtil = (file: fileBlob) => {
    const a = document.createElement('a');
    a.href = URL.createObjectURL(file.blob);
    a.setAttribute('download', `${file.fileName}`);
    a.style.display = 'none';
    a.click();
    URL.revokeObjectURL(a.href);
    return { fileName: file.fileName };
};
export const getFileName = (disposition: string) => {
    let filename = '';
    if (disposition && disposition.indexOf('attachment') !== -1) {
        const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
        const matches = filenameRegex.exec(disposition);
        if (matches !== null && matches[1]) {
            filename = matches[1].replace(/['"]/g, '');
        }
    }
    filename = filename.trim();
    if (filename.includes('UTF-8')) {
        filename = filename.replace('UTF-8', '');
        filename = decodeURIComponent(filename);
    }
    return filename;
};
